import { decrementRequests, incrementRequests } from 'api/fetcher';
import axios from 'axios';

type BannerVideoUploadUrls = {
    videoUrl: string;
    thumbnailUrl: string;
};

const uploadUrlsRoute = '/api/v1/videos/upload_url/';

export const getUploadUrls = async (signal?: AbortSignal): Promise<BannerVideoUploadUrls> => {
    const instance = axios.create();
    instance.defaults.timeout = 0;
    incrementRequests();
    try {
        const response = await instance.get<BannerVideoUploadUrls>(uploadUrlsRoute, { signal });
        return response.data;
    } catch (error) {
        throw error;
    } finally {
        decrementRequests();
    }
};
